import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixUsers from 'wix-users';
import { session } from 'wix-storage';
import { mainPageEvent } from 'backend/eventFirings.jsw';
import {
	search_on_key_Press,
	optionClickedHomePage,
	changeHoverColor,
	populateSearchRepeater
} from 'public/keyWordSearch.js';
import {
	readFromStorage,
	saveToStorage,
	removeFromStorage,
	setToIndexDB,
	getFromIndexDB,
	deleteIndexDB
} from 'public/storage';
import { hiddenPositionsAmount } from 'public/blackList.js';
import { SITE_URL } from 'public/globals.js';
//coment from dynamic content
let formFactor = wixWindow.formFactor;
let setIntervalTime = 60000;
let teams, locations, gridObjectStr, gridObject;

let baseUrl = '';
let query = '';
let debounceTimer;
let activeRepeater = session.getItem("teams") === 'yes' ? 'Teams' : "Locations";
let activePage = 'Home';

$w.onReady(async () => {
	if (formFactor === "Mobile") {
		$w('#sliderForMobile').show();
		$w('#mobileHamurgerButton').show()
		$w("#loaderBox").hide();
	}
	await showSearchInput();	
	
	setInitialValues();
	baseUrl = SITE_URL.replace("home/", "");
	query =  wixLocation.url.includes('?') ? `?${wixLocation.url.split('?')[1]}` : '';
	await getGridData();
	defaultNavBtnStyle();
	if (formFactor !== "Mobile") {
		setAttributesToVideoControl();
		setAttributesToGridCustomElement();
	}
	if (formFactor === "Mobile") {
		setActiveRepeater();
		populateLocationsRepeater();
		populateLocationsRepeaterWithOpenedPositions();
		populateTeamsRepeater();
		$w("#searchInput").placeholder = ""
	}
	setAttributesToSearchCustomElement();

	await fireEvent();
	setTimeout(() => {
		getDataIndexDB()
	}, 0 * 100);
	setTimeout(() => {
		
		// $w('#searchIcon').show()
		// $w('#mobileMenuIcon').show()
		if(formFactor === 'Mobile'){
			$w("#searchInputBox").show()
			$w("#searchInput").show()
			$w('#searchIcon').show()
			$w("#searchInput").placeholder = "Search";
			$w("#searchInputBox").style.borderColor = "#999997"
			$w("#searchInputBox").style.borderWidth = "1px";
		}
		
	},  1000);
	
	
});

async function showSearchInput() {
	setTimeout(() => {
		$w('#loaderBox').hide();
		$w('#searchInputBox').show();
		$w('#searchInput').show()
	}, 0)
}

function setInitialValues() {
	let searchedValue = session.getItem("searchedValue") ? session.getItem("searchedValue") : "";
	searchedValue = htmlEntities(searchedValue)
	if (searchedValue !== "") {
		$w('#searchInput').value = searchedValue;
	}
	session.removeItem("searchedLocation");
	session.removeItem("searchedPositionID");
	session.removeItem("searchedGuildName");
	session.removeItem("prevPage");
	session.removeItem("positionResultsUrl");

}

function populateTeamsRepeater() {
	$w('#teamsContainer').data = teams;
	$w('#teamsContainer').forEachItem(($item, itemData, index) => {
		$item('#teamText').text = teams[index].name;
		$item('#teamTexWhite').text = teams[index].name;
		if (formFactor !== "Mobile") {
			$item('#teamText').html = $item('#teamText').html.split('#202121">')[0] + '#202121">' + `<a href=${baseUrl}/teams/${teams[index].name.replace(/["'()]/g,"").replace(" & ", "-").replace(/[^a-zA-Z]/g,"-").toLowerCase()} target=_self>${teams[index].name}</a>` + "</span></span></span></p>";
			$item('#teamTexWhite').html = $item('#teamTexWhite').html.split('#FFFFFF">')[0] + '#FFFFFF">' + `<a href=${baseUrl}/teams/${teams[index].name.replace(/["'()]/g,"").replace(" & ", "-").replace(/[^a-zA-Z]/g,"-").toLowerCase()} target=_self>${teams[index].name}</a>` + "</span></span></span></p>";
			$item('#teamBox').onClick((handler) => {
				$item('#teamText').show();
				wixLocation.to('/teams/' + teams[index].name.replace(/["'()]/g, "").replace(" & ", "-").replace(/[^a-zA-Z]/g, "-").toLowerCase());
			});
		} else {
			$item('#teamText').html = $item('#teamText').html.split('#202121;">')[0] + '#202121">' + `<a href=${baseUrl}/teams/${teams[index].name.replace(/["'()]/g,"").replace(" & ", "-").replace(/[^a-zA-Z]/g,"-").toLowerCase()} target=_self>${teams[index].name}</a>` + "</span></span></span></p>";
			$item('#teamContainer').onClick((handler) => {
				$item('#teamText').html = $item('#teamText').html.replace("202121", "1F6CFF");
				wixLocation.to('/teams/' + teams[index].name.replace(/["'()]/g, "").replace(" & ", "-").replace(/[^a-zA-Z]/g, "-").toLowerCase());
			});
		}
	});
}

function populateLocationsRepeater() {
	$w('#locationsContainer').data = locations;
	$w('#locationsContainer').forEachItem(($item, itemData, index) => {
		$item('#locationText').text = locations[index].name;
		$item('#locationTextWhite').text = locations[index].name;
		if (formFactor !== "Mobile") {
			$item('#locationText').html = $item('#locationText').html.split('#202121">')[0] + '#202121">' + `<a href=${baseUrl}/locations/${locations[index].name.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${locations[index].name}</a>` + "</span></span></span></p>";
			$item('#locationTextWhite').html = $item('#locationTextWhite').html.split('#FFFFFF">')[0] + '#FFFFFF">' + `<a href=${baseUrl}/locations/${locations[index].name.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${locations[index].name}</a>` + "</span></span></span></p>";
			$item('#locationBox').onClick((handler) => {
				wixLocation.to('/locations/' + locations[index].name.replace(/\s+/g, "-").toLowerCase());
			});

		} else {
			$item('#locationText').html = $item('#locationText').html.split('#202121;">')[0] + '#202121">' + `<a href=${baseUrl}/locations/${locations[index].name.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${locations[index].name}</a>` + "</span></span></span></p>";
			$item('#locationContainer').onClick((handler) => {
				$item('#locationText').html = $item('#locationText').html.replace("202121", "1F6CFF");
				wixLocation.to('/locations/' + locations[index].name.replace(/\s+/g, "-").toLowerCase());
			});
		}
	});

}

function populateLocationsRepeaterWithOpenedPositions() {
	$w('#locationsContainer').data = locations;
	$w('#locationsContainer').forEachItem(($item, itemData, index) => {
		const cityName = locations[index].name.trim();
		$item('#locationText').text = cityName;
		$item('#locationTextWhite').text = cityName;
		let productionSitePositions = hiddenPositionsAmount[locations[index].name] || 0;
		const openedPositions = locations[index].positionsAmount - productionSitePositions || '0';
		$item('#weatherText').text = `${openedPositions} Open Positions`;
		if (formFactor !== "Mobile") {
			$item('#locationText').html = $item('#locationText').html.split('#202121">')[0] + '#202121">' + `<a href=${baseUrl}/locations/${cityName.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${cityName}</a>` + "</span></span></span></p>";
			$item('#locationTextWhite').html = $item('#locationTextWhite').html.split('#FFFFFF">')[0] + '#FFFFFF">' + `<a href=${baseUrl}/locations/${cityName.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${cityName}</a>` + "</span></span></span></p>";
			$item('#locationBox').onClick((handler) => {
				wixLocation.to('/locations/' + cityName.replace(/\s+/g, "-").toLowerCase());
			});

		} else {
			$item('#locationText').html = $item('#locationText').html.split('#202121;">')[0] + '#202121;">' + `<a href=${baseUrl}/locations/${cityName.replace(/\s+/g, "-").replace('/', '%2F').toLowerCase()} target=_self>${cityName}</a>` + "</span></span></span></p>";
			$item('#locationContainer').onClick((handler) => {
				$item('#locationText').html = $item('#locationText').html.replace("202121", "1F6CFF");
				wixLocation.to('/locations/' + cityName.replace(/\s+/g, "-").toLowerCase());
			});
		}
	});
}

//locations container event
export function locationContainer_mouseIn(event, $w) {
	if (formFactor !== "Mobile") {
		$w('#locationBox').show();
		$w('#locationText').hide();
	}
}
export function locationContainer_mouseOut(event, $w) {
	if (formFactor !== "Mobile") {
		$w('#locationBox').hide();
		$w('#locationText').show();
	}
}
//teams container event
export function teamContainer_mouseIn(event, $w) {
	if (formFactor !== "Mobile") {
		$w('#teamBox').show();
		$w('#teamText').hide();
	}
}
export function teamContainer_mouseOut(event, $w) {
	if (formFactor !== "Mobile") {
		$w('#teamBox').hide();
		$w('#teamText').show();
	}
}
async function fireEvent() {
	const distinctId = wixUsers.currentUser.id;
	const initialReferrer = wixWindow.referrer || null;
	let initialDomainReferrer = null;
	let jobClientReferrer = null;
	if (initialReferrer) {
		initialDomainReferrer = wixWindow.referrer.substr(8, wixWindow.referrer.indexOf('.'));
		jobClientReferrer = wixWindow.referrer.substr(8, wixWindow.referrer.indexOf('.'));
	}
	const jobClientSessionId = '4e05c5cc-8ce7-449d-8d90-7cc6687e2df7';
	mainPageEvent(distinctId, initialReferrer, initialDomainReferrer, jobClientReferrer, jobClientSessionId);
}

export function startNow1_click(event) {
	let locationsBtn = $w('#locationsBtn');
	let locationsBtnId = locationsBtn.uniqueId;
	$w('#searchCustomElement').setAttribute('page', activePage);
	$w('#searchCustomElement').setAttribute('focusbtn-id', locationsBtnId);
	$w('#searchCustomElement').setAttribute('focus', Math.random());
	if (formFactor === "Mobile") {
		$w("#vectorImage20").show();
		$w("#searchInputBox").hide();
	}
	$w('#navBox').scrollTo();
}


async function getGridData(){
	[locations, teams] = await Promise.all([wixData.query('Locations-Dynamic').find(), wixData.query('Teams-Dynamic').find()]);
	locations = locations.items;
	locations.sort((a, b) => (Number(a.sort_order) > Number(b.sort_order)) ? 1 : ((Number(b.sort_order) > Number(a.sort_order)) ? -1 : 0));
	teams = teams.items;
	teams.sort((a, b) => (Number(a.sort_order) > Number(b.sort_order)) ? 1 : ((Number(b.sort_order) > Number(a.sort_order)) ? -1 : 0));
}

function defaultNavBtnStyle() {
	if (activeRepeater === 'Locations') {
		$w('#locationsBtn').style.color = "#1F6CFF";
		$w('#teamsBtn').style.color = "#000";
	} else {
		$w('#locationsBtn').style.color = "#000";
		$w('#teamsBtn').style.color = "#1F6CFF";
	}
}

function setActiveRepeater() {
	if (activeRepeater === 'Locations') {
		$w('#locationsContainer').show();
		$w('#teamsContainer').hide();
	} else {
		$w('#teamsContainer').show();
		$w('#locationsContainer').hide();
	}
}

async function getDataIndexDB() {
	let searchResults = await getFromIndexDB('results');
	if (searchResults) {
		searchResults = JSON.parse(searchResults);
		searchResults.push({
			_id: (new Date().getTime() * 500).toString(),
			title: "See all results for " + $w("#searchInput").value,
			type: 'all',
			location_title: '',
			guildName: ''
		});
		populateSearchRepeater(searchResults);
	}
}

export function locationsBtn_click(event) {
	activeRepeater = 'Locations';
	if (formFactor !== 'Mobile') {
		gridObject.activeRepeater = activeRepeater;
		gridObjectStr = JSON.stringify(gridObject);
		$w('#gridCustomElement').setAttribute('data', gridObjectStr);
	}
	$w('#locationsBtn').style.color = "#1F6CFF";
	$w('#teamsBtn').style.color = "#000";

	if (formFactor === "Mobile") {
		$w('#locationsContainer').show();
		$w('#teamsContainer').hide();
	}

	// $w('#teamsContainer').hide();
	// $w('#locationsContainer').show();
}

export function locationsBtn_mouseIn(event) {
	$w('#locationsBtn').style.color = "#1F6CFF";
}

export function locationsBtn_mouseOut(event) {
	if (activeRepeater === 'Locations') {
		$w('#locationsBtn').style.color = "#1F6CFF";

	} else {
		$w('#locationsBtn').style.color = "#000";

	}
}

export function teamsBtn_click(event) {
	activeRepeater = 'Teams';
	if (formFactor !== 'Mobile') {
		gridObject.activeRepeater = activeRepeater;
		gridObjectStr = JSON.stringify(gridObject);
		$w('#gridCustomElement').setAttribute('data', gridObjectStr);
	}
	$w('#locationsBtn').style.color = "#000";
	$w('#teamsBtn').style.color = "#1F6CFF";
	if (formFactor === "Mobile") {
		$w('#locationsContainer').hide();
		$w('#teamsContainer').show();
	}
	// $w('#teamsContainer').show();
	// $w('#locationsContainer').hide();
}

export function teamsBtn_mouseIn(event) {
	$w('#teamsBtn').style.color = "#1F6CFF";
}

export function teamsBtn_mouseOut(event) {
	if (activeRepeater === 'Teams') {
		$w('#teamsBtn').style.color = "#1F6CFF";
	} else {
		$w('#teamsBtn').style.color = "#000";
	}
}

export function landingStrip_viewportEnter(event) {
	if (formFactor !== "Mobile") {
		$w('#arrowBox').hide();
	}
}

export function landingStrip_viewportLeave(event) {
	if (formFactor !== "Mobile") {
		$w('#arrowBox').show("fade");
	}
}

function setAttributesToVideoControl() {
	const pauseBtn = $w('#pauseBtn');
	const pauseBtnId = pauseBtn.uniqueId;
	$w('#videoControlElement').setAttribute('btn-id', pauseBtnId);
}

function setAttributesToSearchCustomElement() {
	const searchInput = $w('#searchInput');
	const searchInputId = searchInput.uniqueId;
	$w('#searchCustomElement').setAttribute('input-id', searchInputId);
	$w('#searchCustomElement').setAttribute('page', activePage);
}

function setAttributesToGridCustomElement() {
	gridObject = {
		locations,
		teams,
		activeRepeater,
		hiddenPositionsAmount,
		query
	}
	gridObjectStr = JSON.stringify(gridObject);
	$w('#gridCustomElement').setAttribute('base-url', baseUrl);
	$w('#gridCustomElement').setAttribute('data', gridObjectStr);
}

//----------------------------------- Search related functions ---------------------------------------------

export function search(event, $w) {
	if ($w('#searchInput').value.length > 0) {
			// $w('#searchRepeater').expand();
		if (formFactor !== 'Mobile') {
			$w('#searchInputClearBtn').show();
		} else {
			$w('#searchInputClearBtn1').show();
		}
		search_on_key_Press(event, $w, );

	} else if ($w('#searchInput').value.length === 0) {
		if (formFactor !== 'Mobile') {
			$w('#searchInputClearBtn').hide();
		} else {
			$w('#searchInputClearBtn1').hide();
		}
		$w('#searchRepeaterBox').collapse();
		if (formFactor === "Mobile") {
			$w('#mobileBox').hide();
		}
		$w("#searchInputBox").style.borderColor = "#999997"
		$w("#searchInputBox").style.borderWidth = "1px";
	} else {
		if (formFactor !== 'Mobile') {
			$w('#searchInputClearBtn').hide();
		} else {
			$w('#searchInputClearBtn1').hide();
		}
		$w('#searchRepeater').data = [];
		
		$w('#searchRepeaterBox').collapse();
		if (formFactor === "Mobile") {
			$w('#mobileBox').hide();
		}
		session.removeItem("searchedValue");
	}
}

export function searchInput_keyPress(event, $w) {
	if (debounceTimer) {
		clearTimeout(debounceTimer);
		debounceTimer = undefined;
	}
	debounceTimer = setTimeout(search, 300, event, $w);
}

export function searchContainer_mouseIn(event) {
	session.removeItem("isInputActive");
	changeHoverColor(event);
}

export function searchContainer_click(event, $w) {
	optionClickedHomePage(event, $w);
}

export function searchBtn_click(event) {
	$w('#searchInput').show();
	$w('#searchInput').focus();
}

export function searchInput_blur(event) {
	setTimeout(() => {
		$w('#searchRepeater').collapse();
		if (formFactor === "Mobile") {
			$w('#mobileBox').hide();
		}
		$w('#searchRepeaterBox').collapse();
		$w("#searchInputBox").style.borderColor = "#999997"
		$w("#searchInputBox").style.borderWidth = "1px";
	}, 150)
}

export async function searchInput_focus(event) {
	if ($w('#searchInput').value && $w('#searchRepeater').data) {
		if (formFactor !== 'Mobile') {
			$w('#searchInputClearBtn').show();
		} else {
			$w('#searchInputClearBtn1').show();
		}
		$w('#searchRepeaterBox').expand();
		$w('#searchRepeater').expand();
	// 	setTimeout(() => {
		
	// }, 150)
		
		
		if (formFactor !== "Mobile") {
			$w("#searchInputBox").style.borderColor = "#FFFFFF";
			$w("#searchInputBox").style.borderWidth = "0px";
		}
		session.removeItem("searchedPositionID");
		session.removeItem("searchedLocation");
	}
}

export function searchInputClearBtn_click(event) {
	if (formFactor === "Mobile") {
		$w('#mobileBox').hide();
	}
	session.removeItem("searchedValue");

	if (formFactor !== 'Mobile') {
		$w('#searchInputClearBtn').hide();
	} else {
		$w('#searchInputClearBtn1').hide();
	}
	$w('#searchRepeater').collapse();
	$w('#searchRepeaterBox').collapse();
	$w("#searchInputBox").style.borderColor = "#999997"
	$w("#searchInputBox").style.borderWidth = "1px";
	$w('#searchInput').value = '';
	$w('#searchInput').focus();
}

export async function searchIcon_click() {
	let value = $w("#searchInput").value;
	value = htmlEntities(value)
	let isSearchInputBoxHide = $w("#searchInputBox").hidden;
	if (formFactor === "Mobile") {
		if (isSearchInputBoxHide) {
			$w("#searchInputBox").style.borderColor = "#999997"
			$w("#searchInputBox").style.borderWidth = "1px";
			$w("#searchInputBox").show();

			setTimeout(() => {
		$w("#searchInput").focus()
	},  100);
	

		} else {
			session.removeItem("searchedLocation");
			session.removeItem('searchedPositionID');
			session.setItem("searchedValue", value);
			let linkToSearchResults = '/search?val=' + session.getItem("searchedValue").toLowerCase().replace(/ /g, "-");
			let dropDownData = JSON.parse(session.getItem('dropDownData'));
			if (dropDownData.length > 1 && value.length > 0) {
				wixLocation.to(linkToSearchResults);
			}
		}
	} else {
		session.removeItem("searchedLocation");
		session.removeItem('searchedPositionID');
		session.setItem("searchedValue", value);
		let linkToSearchResults = '/search?val=' + session.getItem("searchedValue").toLowerCase().replace(/ /g, "-");
		let dropDownData = JSON.parse(session.getItem('dropDownData'));
		if (dropDownData.length > 1) {
			wixLocation.to(linkToSearchResults);
		}
	}
}

export function searchInput_click(event) {
	session.setItem("isInputActive", "true");
}

export function searchInputBox_viewportLeave(event) {
	let prefix = wixLocation.prefix;
	if (formFactor === "Mobile" && prefix !== "search") {
		$w("#vectorImage20").show();
		// $w("#searchInputBox").hide();
		$w("#mobileBox").hide();
	}
}


export function pauseBtn_click(event) {
	if (formFactor !== "Mobile") {
		let label = $w('#pauseBtn').label;
		let isPlaying = label === 'Pause' ? 1 : 0;
		if (isPlaying) {
			$w('#pauseBtn').label = 'Play';
		} else {
			$w('#pauseBtn').label = 'Pause';
		}

		$w('#videoControlElement').setAttribute('data', isPlaying);
	}
}

export function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
